import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import type { AutomationLog } from 'modules/Settings/Automation/api';
import { capitalize } from 'remeda';

import { ResourceAnchor } from './ResourceAnchor';

type UnpauseItemProps = {
  log: AutomationLog;
};

export const UnpauseItem = ({ log }: UnpauseItemProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <Group gap={4}>
        <Text>{t(i18nKeys.AUTOMATION.HISTORY_PANEL.UNPAUSE.THE_CUSTOMER)}</Text>
        <ResourceAnchor log={log} />
        <Text>{t(i18nKeys.AUTOMATION.HISTORY_PANEL.UNPAUSE.WAS_UNPAUSED)}</Text>
      </Group>
      <Text size="sm">{capitalize(dayjs().to(log.date))}</Text>
    </Stack>
  );
};
